import { apiClient } from '@/shared/api/client';
import { GetBalanceSnapshotListResponse } from '../types/balanceSnapshot.types';

const BASE_PATH = '/api/v1/balance-snapshot';

export const balanceSnapshotApi = {
    getSnapshotList: async (snapDate: string): Promise<GetBalanceSnapshotListResponse> => {
        const response = await apiClient.get<GetBalanceSnapshotListResponse>(
            `${BASE_PATH}/list`,
            { params: { snapDate } }
        );
        return response.data;
    },
};
